<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../../components/SearchHeader.svelte";
  import { Table } from "../../../components/Table";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import { qualityMaintenanceScheduleFields } from "../../../utils/TableFields/quality-maintenance-schedule.fields";

  import { filter, loading, records, pagination, initList, onCreate, onEdit, onDelete, onPageChange, search } from "./quality-maintenance-schedule.store";

  onMount(initList);
</script>

<QualityLayout>
  <SearchHeader
    entitySingular="scadenziario manutenzioni"
    entityPlural="scadenziario manutenzioni"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  />

  <Table
    loading={$loading}
    fields={qualityMaintenanceScheduleFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</QualityLayout>
